// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__EZb6O","list":"PatternAutocomplete_list__2Q8Wb"};